import React from 'react';
import styles from '../../styles/contacts/ContactsWorkspace.module.css';
import Dialog from './Dialog';
import { AlertIcon } from './ContactsIcons';

/**
 * Shown when a contact action needs a finished business card.
 * A physical card is not required to save or share a profile.
 */
export function CardIncompleteDialog({ open, onClose, onEditCard }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Finish your business card"
      lead="Add at least your name and email to your business card, then you can share it with any contact."
      footer={
        <div className={styles.dialogFoot}>
          <button type="button" className={`${styles.btn} ${styles.btnGhost}`} onClick={onClose}>
            Not now
          </button>
          <button type="button" className={`${styles.btn} ${styles.btnPrimary}`} onClick={onEditCard}>
            Edit my card
          </button>
        </div>
      }
    >
      <div className={styles.dialogAlert} role="note">
        <AlertIcon size={16} />
        <span>Your profile can be shared without a physical card.</span>
      </div>
    </Dialog>
  );
}
